export default __webpack_public_path__ + "static/media/africa.13a7312a.svg";